import React, { Component } from "react";

// CSS
import "../../styles/newDesign.scss";
import "../../components/HomeBlocks/HomeBlocks.scss";
import "./MyPlans.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { PlanCards } from "../../components/HomeBlocks/HomeBlocks";

// Helper
import { resolveTenant, isLoggedIn, listPlans, myPlans } from "../../Helper/Api";
import { t, getLanguage } from "../../Helper/i18n";
import Toast from "../../components/Toast/Toast";

const properties = require("../../properties.json");

function day(iso) {
  return iso ? new Date(iso).toLocaleDateString(getLanguage() === "en" ? "en-GB" : "ar-EG-u-nu-latn", { day: "numeric", month: "long", year: "numeric" }) : "";
}

// A member's page: the memberships they have and the plans they can ask for or try. Paying is done with the coach on
// the site, not in an app; the coach activates the membership.
class MyPlans extends Component {
  state = { tenant: null, notFound: false, plans: null, mine: null, error: null };

  componentDidMount() {
    if (!isLoggedIn()) {
      window.location.href = "/sign-in";
      return;
    }
    resolveTenant()
      .then((tenant) => {
        document.title = properties.site_name + " - " + t("myPlans");
        this.setState({ tenant });
        listPlans(tenant.teacherUserId).then((plans) => this.setState({ plans: plans || [] })).catch(() => this.setState({ plans: [] }));
        this.load();
      })
      .catch(() => this.setState({ notFound: true }));
  }

  load = () => {
    myPlans()
      .then((mine) => this.setState({ mine: mine || [], error: null }))
      .catch((e) => this.setState({ mine: this.state.mine || [], error: e.message }));
  };

  render() {
    const { tenant, notFound, plans, mine, error } = this.state;
    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center"><p>{t("notFound")}</p></div>
        </div>
      );
    }
    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />
        <div className="nd-page hb-page myplans">
          <div className="hb-wrap">
            <h1 className="hb-title nd-title">{t("myPlans")}</h1>
            <p className="hb-lead">{t("myPlansLead")}</p>
            <Toast msg={error} type="error" />

            <h2 className="mp-sub">{t("yourMemberships")}</h2>
            {mine === null ? (
              <p className="hb-muted">{t("loading")}</p>
            ) : mine.length === 0 ? (
              <p className="hb-muted">{t("noMemberships")}</p>
            ) : (
              <div className="mp-list">
                {mine.map((m) => (
                  <div className={`mp-row st-${m.status}`} key={m.id}>
                    <div>
                      <b>{m.planName}</b>
                      <span className="hb-chip">{t("status" + m.status)}</span>
                    </div>
                    {m.endsAt && <div className="hb-muted">{t("until", { date: day(m.endsAt) })}</div>}
                  </div>
                ))}
              </div>
            )}

            <h2 className="mp-sub">{t("askForPlan")}</h2>
            {plans === null ? <p className="hb-muted">{t("loading")}</p> : <PlanCards plans={plans} mine={mine} onChanged={this.load} />}
            <p className="hb-muted hb-pay-note">{t("payNote")}</p>
          </div>
        </div>
        <Footer tenant={tenant} />
      </>
    );
  }
}

export default MyPlans;
